(() => {
  if (customElements.get('aven-looping-media')) return;
  customElements.define('aven-looping-media', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const visible = new Set();
      const videos = [...this.querySelectorAll('video')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const sync = video => {
        if (!this.isConnected) return;
        if (visible.has(video) && !document.hidden && !reducedMotion.matches) {
          video.muted = true;
          video.play()?.catch(() => {});
        } else if (!video.paused) video.pause();
      };
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) visible.add(target);
          else visible.delete(target);
          sync(target);
        });
      }, { threshold: 0.05 });
      videos.forEach(video => {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        // Gallery changes pause all theme videos; resume only the visible muted tiles.
        video.addEventListener('pause', () => queueMicrotask(() => sync(video)), { signal });
        this.observer.observe(video);
      });
      document.addEventListener('visibilitychange', () => videos.forEach(sync), { signal });
      reducedMotion.addEventListener('change', () => videos.forEach(sync), { signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
})();
